// removed by extract-text-webpack-plugin
module.exports = {"stateInfoWrap":"qempo_StateInfoBox_stateInfoWrap-2eM15Kn","imageWrap":"qempo_StateInfoBox_imageWrap-Lib7ZmX","textWrap":"qempo_StateInfoBox_textWrap-13-iJAU","title":"qempo_StateInfoBox_title-172Q-O3","subtitle":"qempo_StateInfoBox_subtitle-3ZrrURk","stateInfoWrapRule":"qempo_StateInfoBox_stateInfoWrapRule-1ATtQS6"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/order/components/StateInfoBox/StateInfoBox.scss
// module id = 1838
// module chunks = 0